import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const DepositModalLazy = React.lazy(() =>
  import('./DepositModal').then((m) => ({ default: m.DepositModal })),
);

NiceModal.register(
  MODALS.DEPOSIT,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <DepositModalLazy />
    </Suspense>
  )),
);
